import { Link } from 'react-router-dom';
import { categories, getComicsByCategory } from '@/mocks/comics';

export default function CategoryShowcase() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6">
      <div className="mb-8 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-2xl text-foreground-950">三大暗黑专区</h2>
          <p className="mt-2 text-sm text-foreground-600">按题材快速找到你喜欢的深夜剧情漫画</p>
        </div>
        <Link to="/category/shenye" className="hidden items-center gap-1 text-sm text-primary-400 transition-colors hover:text-primary-300 sm:flex">
          全部漫画 <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {categories.map((cat) => {
          const count = getComicsByCategory(cat.slug).length;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-2xl border border-background-200/60"
            >
              <div className="relative h-52 w-full overflow-hidden md:h-60">
                <img
                  src={cat.banner}
                  alt={`${cat.name}专区`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/10"></div>
                <div className="absolute inset-x-0 bottom-0 p-5">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="font-heading text-xl text-foreground-950">{cat.name}</h3>
                      <p className="mt-1 text-xs text-foreground-400">{cat.en} · {count} 部精选</p>
                    </div>
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                      <i className="ri-arrow-right-line" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}